import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Autoplay } from "swiper/modules";
import { Image } from "antd";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/autoplay";

const SliderWithPreview = ({ images }) => {
  return (
    <Image.PreviewGroup
      preview={{
        onChange: (current, prev) =>
          console.log(`current index: ${current}, prev index: ${prev}`),
      }}
    >
      <Swiper
        loop={true} // Enable infinite looping
        slidesPerView={3} // Default slides visible
        spaceBetween={30} // Default space between slides
        freeMode={true} // Enable free scroll mode
        pagination={{
          clickable: true,
        }} // Clickable pagination
        autoplay={{
          delay: 3000, // Time in ms between slides
          disableOnInteraction: false, // Continue autoplay after interaction
        }} // Configure autoplay
        grabCursor={true} // Add hand drag cursor
        breakpoints={{
          // Responsive breakpoints
          320: {
            slidesPerView: 1, // 1 slide for small screens
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 2, // 2 slides for medium screens
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3, // 3 slides for larger screens
            spaceBetween: 30,
          },
        }}
        modules={[FreeMode, Pagination, Autoplay]} // Include modules
        className="mySwiper"
      >
        {images && images.length > 0 ? (
          images.map((image, index) => (
            <SwiperSlide key={index}>
              <Image
                width="100%"
                src={`${process.env.REACT_APP_BASE}${image}`}
                alt={`Slide ${index + 1}`}
              />
            </SwiperSlide>
          ))
        ) : (
          <SwiperSlide>No Images Available</SwiperSlide>
        )}
      </Swiper>
    </Image.PreviewGroup>
  );
};

export default SliderWithPreview;
